var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { attrs: { "no-body": "" } },
        [
          _c(
            "b-card-header",
            [
              _c("b", [_vm._v("LA Labor Trafficking Tool")]),
              _vm._v(" "),
              _vm.isAllowedToCreateOrEditPerson
                ? _c(
                    "router-link",
                    { attrs: { to: _vm.addLaborScreeningLink } },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "headerBtn",
                          attrs: { variant: "outline-primary" }
                        },
                        [_vm._v("Add Screening")]
                      )
                    ],
                    1
                  )
                : _c(
                    "b-button",
                    {
                      staticClass: "headerBtn",
                      attrs: { disabled: "", variant: "outline-primary" }
                    },
                    [_vm._v("Add Screening")]
                  )
            ],
            1
          ),
          _vm._v(" "),
          _vm.laborScreenings.length > 0
            ? _c(
                "div",
                [
                  _vm._l(_vm.laborScreenings, function(ls) {
                    return _c(
                      "b-list-group",
                      { key: ls.id, attrs: { flush: "" } },
                      [
                        _c(
                          "b-list-group-item",
                          [
                            _c(
                              "router-link",
                              {
                                attrs: {
                                  to:
                                    "/laborscreening/" +
                                    ls.id +
                                    "/view/conclusion"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm
                                        .$moment(ls.createdAt)
                                        .format("MM/DD/YYYY")
                                    ) +
                                    " " +
                                    _vm._s(ls.id) +
                                    "\n                        "
                                ),
                                ls.conclusion ===
                                _vm.LABOR_SCREENING_CONCLUSION.LEVEL1
                                  ? _c("img", {
                                      staticClass: "ls-icon",
                                      attrs: {
                                        src: "/static/img/ConcernPossible.png",
                                        height: "21",
                                        width: "21"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                ls.conclusion ===
                                _vm.LABOR_SCREENING_CONCLUSION.LEVEL2
                                  ? _c("img", {
                                      staticClass: "ls-icon",
                                      attrs: {
                                        src: "/static/img/ConcernDanger.png",
                                        height: "21",
                                        width: "21"
                                      }
                                    })
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.lsIsShared(ls)
                                  ? _c("img", {
                                      attrs: {
                                        src: "/static/img/shareYes.png",
                                        height: "21",
                                        width: "21"
                                      }
                                    })
                                  : _vm._e()
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }),
                  _vm._v(" "),
                  _vm.isAllowedToCreateOrEditPerson
                    ? _c(
                        "router-link",
                        {
                          attrs: {
                            to: "/person/" + _vm.personId + "/edit?tabIndex=1"
                          }
                        },
                        [
                          _c(
                            "b-button",
                            {
                              staticClass: "mb-3",
                              staticStyle: { "margin-left": "1.25rem" },
                              attrs: {
                                type: "button",
                                variant: "danger",
                                size: "md"
                              }
                            },
                            [
                              _c("span", { staticClass: "button-text" }, [
                                _vm._v("Update Victim Status")
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                2
              )
            : _c(
                "div",
                [
                  _c(
                    "b-list-group",
                    { attrs: { flush: "" } },
                    [
                      _c("b-list-group-item", [
                        _c("p", [
                          _vm._v(
                            "\n                        No Labor Screenings\n                    "
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-39758d8c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39758d8c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LaborScreening/ShareLaborScreening.vue
// module id = 1610
// module chunks = 0